import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { NativeAudio } from 'ionic-native';
import { SmartAudio } from '../../providers/smart-audio';
import { CPS } from '../../providers/cps';
import { ThankYouPage } from '../thankyou/thankyou';

/*
  Generated class for the Item page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-item',
  templateUrl: 'item.html'
})
export class ItemPage {
  //
  X: HTMLImageElement;
  L: HTMLImageElement;
  R: HTMLImageElement;
  ImageByClassX: any            = {};
  ImageByClassL: any            = {};
  ImageByClassR: any            = {};
  LisA: boolean                 = true;
  XSnd: string                  = "";
  LSnd: string                  = "";
  RSnd: string                  = "";
  Index: number                 = 0;
  runItem : any                 = null;
  chooseCtn : any               = null;
  LeftTeddyDisabled : boolean   = true;
  RightTeddyDisabled : boolean  = true;
  Parameters: Map<string,any>   = new Map([["test",{"a":"b"}]]);
  //
  constructor(
    private smartAudio: SmartAudio
    , private cps: CPS
    , private navCtrl: NavController
  ) {
    this.LeftTeddyDisabled      = true;
    this.RightTeddyDisabled     = true;
    //
    this.ImageByClassX          = {
      "Down": "owl-plain.png"
      , "XSpeaks": "owl-speaking.png"
      , "LSpeaks": "owl-his-right.png"
      , "RSpeaks": "owl-his-left.png"
      , "ButtonsHigh": "owl-plain.png"
      , "LChosen": "owl-plain.png"
      , "RChosen": "owl-plain.png"
    };
    this.ImageByClassL          = {
      "Down": "teddy-plain.png"
      , "XSpeaks": "teddy-right.png"
      , "LSpeaks": "teddy-speaking.png"
      , "RSpeaks": "teddy-right.png"
      , "ButtonsHigh": "teddy-button-ready.png"
      , "LChosen": "teddy-button-accepted.png"
      , "RChosen": "teddy-button-denied.png"
    };
    this.ImageByClassR          = {
      "Down": "teddy-plain.png"
      , "XSpeaks": "teddy-left.png"
      , "LSpeaks": "teddy-left.png"
      , "RSpeaks": "teddy-speaking.png"
      , "ButtonsHigh": "teddy-button-ready.png"
      , "LChosen": "teddy-button-denied.png"
      , "RChosen": "teddy-button-accepted.png"
    };
    this.setParameter("sounds",
                      {
                        "seeh":"AD01_deet_happy_01_10ms_normalized.wav"
                        ,"sih":"AD01_dit_happy_011_10ms_200msDur_normalized.wav"
                        ,"sooh":"AD01_doot_happy_011_10ms_normalized.wav"
                        ,"seehh":"AD02_deet_highHappy_012_10ms_normalized.wav"
                        ,"sihh":"AD02_dit_highHappy_012_10ms_normalized.wav"
                        ,"soohh":"AD02_doot_highHappy_012_10ms_normalized.wav"
                      });
    this.setParameter("experiment",[
      {"X":"sih","A":"seeh","B":"sihh","FirstSide":"Left","Choice":"?"}
      , {"X":"sooh","A":"seeh","B":"soohh","FirstSide":"Right","LRChoice":"?","ABChoice":"?"}
      , {"X":"seehh","A":"seeh","B":"soohh","FirstSide":"Left","LRChoice":"?","ABChoice":"?"}
      // , {"X":"sih","A":"sooh","B":"sihh","FirstSide":"Left","Choice":"?"}
      // , {"X":"sooh","A":"sih","B":"soohh","FirstSide":"Right","LRChoice":"?","ABChoice":"?"}
      // , {"X":"seehh","A":"seeh","B":"sihh","FirstSide":"Left","LRChoice":"?","ABChoice":"?"}
      // , {"X":"sih","A":"seehh","B":"sihh","FirstSide":"Left","Choice":"?"}
      // , {"X":"sooh","A":"seeh","B":"sooh","FirstSide":"Right","LRChoice":"?","ABChoice":"?"}
      // , {"X":"seehh","A":"seehh","B":"soohh","FirstSide":"Left","LRChoice":"?","ABChoice":"?"}
      // , 
    ]);
    this.setParameter("beforeXms", 900);
    this.setParameter("afterXms", 1600);
    this.setParameter("afterAms", 1600);
    this.setParameter("afterBms", 1600);
    this.setParameter("beforeSound", 900);
    this.setParameter("afterSound",  900);
    this.setParameter("afterSelect", 900);
    //
    this.runItemS();
  }
  setParameter(key,value) {
    this.Parameters[key]        = value;
  }
  ionViewDidLoad() {
    this.X = document.getElementById("X") as HTMLImageElement;
    this.L = document.getElementById("L") as HTMLImageElement;
    this.R = document.getElementById("R") as HTMLImageElement;
    //
    for (let code in this.Parameters["sounds"]) {
      let filename              = this.Parameters["sounds"][code];
      this.smartAudio.preload(code, '../assets/snd/xabStim/'+filename );
      console.log("Loaded: "+ code +": "+ '../assets/snd/xabStim/'+filename );
    }
    //
    // this.navCtrl.setRoot(this); // This causes promise uncaught errors
    console.log('ionViewDidLoad ItemPage');
    //
    this.runItem( this.cps.empty );
  }
  // ==========================================================================
  // Set the question
  // ==========================================================================
  // ==========================================================================
  // Button callbacks
  // ==========================================================================
  chooseLeft() {
    if (this.LisA)
      this.Parameters["experiment"][this.Index]["Choice"] = "A";
    else this.Parameters["experiment"][this.Index]["Choice"] = "B";
    this.Parameters["experiment"][this.Index]["LRChoice"] = "L";
    console.log('chooseRight '+this.Index.toString());
    return this.chooseCtn();
  }
  chooseRight() {
    if (this.LisA)
      this.Parameters["experiment"][this.Index]["ABChoice"] = "B";
    else this.Parameters["experiment"][this.Index]["ABChoice"] = "A";
    this.Parameters["experiment"][this.Index]["LRChoice"] = "R";
    console.log('chooseRight '+this.Index.toString());
    return this.chooseCtn();
  }
  // ==========================================================================
  // CPS code
  // ==========================================================================
  setupItemS() {
    return (ctn) => {
      this.LisA                 = (this.Parameters["experiment"][this.Index]["FirstSide"] == "L");
      this.XSnd                 = this.Parameters["experiment"][this.Index]["X"];
      if (this.LisA) {
        this.LSnd               = this.Parameters["experiment"][this.Index]["A"];
        this.RSnd               = this.Parameters["experiment"][this.Index]["B"];
      } else {
        this.LSnd               = this.Parameters["experiment"][this.Index]["B"];
        this.RSnd               = this.Parameters["experiment"][this.Index]["A"];
      }
      return ctn();
    };
  }
  delayS(param : string) {
    return (ctn) => {
      return setTimeout(() => {
        console.log("After timeout of "+this.Parameters[param].toString()+" ms");
        return ctn();
      },this.Parameters[param]);
    };
  }
  playSoundByAnimalS(snd : string) {
    return (ctn) => {
      console.log("Playing sound "+snd);
      this.smartAudio.play(this[snd]).then(() => { ctn(); });
    };
  }
  changeClassNamesS(className : string) {
    return (ctn) => {
      this.X.className          = className;
      this.L.className          = className;
      this.R.className          = className;
      this.X.src                = "../../assets/img/" + this.ImageByClassX[className];
      this.L.src                = "../../assets/img/" + this.ImageByClassL[className];
      this.R.src                = "../../assets/img/" + this.ImageByClassR[className];
      console.log('changeClassNamesS '+className);
      return( ctn() );
    };
  }
  playXLRS(speaker : string) {
    return this.cps.sequence(
      this.changeClassNamesS(speaker+"Speaks")
      , this.delayS("beforeSound")
      , this.playSoundByAnimalS(speaker+"Snd")
      , this.delayS("afterSound")
      , this.changeClassNamesS("Down")
    );
  }
  leftFirstS() {
    return (ctn) => { return this.LisA; };
  }
  leftChosenS() {
    return (ctn) => {
      return (this.Parameters["experiment"][this.Index]["LRChoice"] == "L");
    };
  }
  buttonsHighS() {
    return (ctn) => {
      this.chooseCtn            = ctn;
      this.LeftTeddyDisabled    = false;
      this.RightTeddyDisabled   = false;
      return null;
    };
  }
  buttonsDownS() {
    return (ctn) => {
      this.LeftTeddyDisabled    = true;
      this.RightTeddyDisabled   = true;
      return ctn();
    };
  }
  incrementIndexS() {
    return (ctn) => {
      this.Index                = this.Index + 1;
      return ctn();
    };
  }
  atEndS() {
    return (ctn) => {
      return (this.Index >= this.Parameters["experiment"].length)
    };
  }
  gotoThankYouPageS() {
    return (ctn) => {
      this.navCtrl.push(ThankYouPage);
      return ctn();
    };
  }
  loopS() {
    return (ctn) => {
      return this.runItem(ctn);
    };
  }
  runItemS() {
    this.runItem                = this.cps.sequence(
      this.setupItemS()
      , this.changeClassNamesS("Down")
      , this.delayS("beforeXms")
      , this.playXLRS("X")
      , this.delayS("afterXms")
      , this.cps.ifthenelseS(
        this.leftFirstS()
        , this.playXLRS("L")
        , this.playXLRS("R")
      )
      , this.delayS("afterAms")
      , this.cps.ifthenelseS(
        this.leftFirstS()
        , this.playXLRS("R")
        , this.playXLRS("L")
      )
      , this.delayS("afterBms")
      , this.changeClassNamesS("ButtonsHigh")
      , this.buttonsHighS()
      , this.buttonsDownS()
      , this.cps.ifthenelseS(
        this.leftChosenS()
        , this.changeClassNamesS("LChosen")
        , this.changeClassNamesS("RChosen")
      )
      , this.delayS("afterSelect")
      , this.changeClassNamesS("Down")
      , this.incrementIndexS()
      , this.cps.ifthenelseS(
        this.atEndS()
        , this.gotoThankYouPageS()
        , this.loopS()
      )
    );
    return this.runItem;
  }
}



// WEBPACK FOOTER //
// ./src/pages/item/item.ts